<template lang="pug">

div(:class="segment === true ? 'ui segment' : (segment || '')")

    //- Name
    text-field(label='Name' v-model='name' v-bind:isRequired='true')
        error-field(v-bind:validation='validation' attribute='name')

    //- Auftraggeber
    dropdown-field(
        label='Auftraggeber'
        v-bind:options='purchaserModels'
        v-bind:isRequired='true'
        v-model='company'
        v-if='$auth.isZmuekish'
    )
        error-field(v-bind:validation='validation' attribute='company')

    //- Mitarbeiter
    multi-dropdown-field(
        label='Mitarbeiter'
        v-bind:options='userOptions'
        v-bind:isRequired='true'
        v-model='campaignUsers'
        v-if='userModels.length > 0'
    )
        error-field(v-bind:validation='validation' attribute='campaignUsers')

    //- Beginn & Ende
    .two.fields

        //- Beginn
        date-field(label='Beginn' v-model='start' v-bind:isRequired='false')

        //- Ende
        date-field(label='Ende' v-model='end' v-bind:isRequired='false')

    //- Gesamtbudget
    .two.fields

        //- Von
        number-field(label='Von in €' v-model='lowerLimit' v-bind:isRequired='false')

        //- Bis
        number-field(label='Bis in €' v-model='budget' v-bind:isRequired='false')


</template>

<script>
    import * as R from 'ramda'
    import { Validator } from 'simple-vue-validator'
    import { full_name } from '@/utils/person'
    import DateField from '@/components/form/DateField'
    import Error from '@/components/form/FieldError'
    import ErrorField from '@/components/form/SmartFieldError'
    import DropdownField from '@/components/form/DropdownField'
    import MultiDropdownField from '@/components/form/MultiDropdownField'
    import NumberField from '@/components/form/NumberField'
    import TextField from '@/components/form/TextField'

    //noinspection JSUnusedGlobalSymbols
    export default {

        components: { DateField, DropdownField, Error, ErrorField, MultiDropdownField, NumberField, TextField },

        computed: {

            budget: {
                get() { return this.value.budget },
                set(value) { this.updateValue('budget', value) }
            },

            company: {
                get() { return this.value.company },
                set(value) {
                    R.composeP(
                        payload => { this.$emit('input', payload) },

                        // Payload/Model vorbereiten
                        () => ({ ...this.value, company: value }),

                        // Benutzer und Personen des Unternehmens laden
                        companyId => Promise.all([
                            this.$store.dispatch('users/loadAllByCompanyId', { companyId }),
                            this.$store.dispatch('persons/loadAllByCompanyId', { companyId })
                        ])

                    )(value)
                }
            },

            campaignUsers: {
                get() { return this.value.users || [] },
                set(value) { this.updateValue('users', value) }
            },

            end: {
                get() { return this.value.end },
                set(value) { this.updateValue('end', value) }
            },

            lowerLimit: {
                get() { return this.value.lowerLimit },
                set(value) { this.updateValue('lowerLimit', value) }
            },

            name: {
                get() { return this.value.name },
                set(value) { this.updateValue('name', value) }
            },

            personModels() {
                return (this.$store.getters['persons/allByUsers'](this.userModels) || []).filter(Boolean)
            },

            start: {
                get() { return this.value.start },
                set(value) { this.updateValue('start', value) }
            },

            userModels() {
                return this.$store.getters['users/allByCompanyId'](this.company) || []
            },

            userOptions() {
                return this.userModels.map(user => ({
                    id: user.id,
                    name: this.getFullName(user.person)
                }))
            }

        },

        methods: {

            getFullName(personId) {
                return R.compose(

                    R.when(R.is(Object), full_name),

                    R.find(R.propEq('id', personId))

                )(this.personModels)
            },

            updateValue(prop, value) {
                this.$emit('input', R.assoc(prop, value, this.value))
            },

            validate() {
                return this.$validate()
            }

        },

        props: {

            segment: {
                type: [Boolean, String],
                default: true
            },

            purchaserModels: {
                type: Array,
                required: true
            },

            value: {
                type: Object,
                required: true
            }

        },

        validators: {

            campaignUsers(value) {
                return Validator.value(R.defaultTo('', value))
                    .required('Darf nicht leer sein. Bitte Mitarbeiter auswählen')
            },

            company(value) {
                return Validator.value(R.defaultTo('', value))
                    .required('Darf nicht leer sein. Bitte Unternehmen auswählen')
            },

            name(value) {
                return Validator.value(R.defaultTo('', value))
                    .required('Darf nicht leer sein. Bitte Namen angeben')
            },

        },

    }

</script>
